import React from 'react';
import { StyledBody } from './styles';

interface DrawerBodyProps {
  noPadding?: boolean;
}

const DrawerBody: React.FC<DrawerBodyProps> = ({ noPadding, children }) => (
  <StyledBody $noPadding={noPadding}>{children}</StyledBody>
);

export { DrawerBody };
